export default __webpack_public_path__ + "static/media/book-icon.61263ac1.svg";